/**
 * Client-side form validation helpers. These provide fast feedback in the
 * UI, but the backend re-validates everything server-side and is the source
 * of truth for security-sensitive checks.
 */
export const MAX_NOTE_LENGTH = 500;

export function validateRsvpForm(values) {
  const errors = {};

  if (!values.parentFirstName || !values.parentFirstName.trim()) {
    errors.parentFirstName = "First name is required.";
  }
  if (!values.parentLastInitial || !/^[A-Za-z]\.?$/.test(values.parentLastInitial.trim())) {
    errors.parentLastInitial = "Enter a single letter for the last initial.";
  }
  if (!values.parentEmail || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(values.parentEmail.trim())) {
    errors.parentEmail = "Enter a valid email address.";
  }
  if (values.mobile && !/^[0-9()+\-.\s]{7,20}$/.test(values.mobile.trim())) {
    errors.mobile = "Enter a valid phone number, or leave blank.";
  }
  const teenCount = Number(values.teenCount);
  if (!Number.isInteger(teenCount) || teenCount < 1 || teenCount > 10) {
    errors.teenCount = "Enter a number of teens between 1 and 10.";
  }
  if (values.note && values.note.length > MAX_NOTE_LENGTH) {
    errors.note = `Note must be ${MAX_NOTE_LENGTH} characters or fewer.`;
  }
  if (!values.isAdult) {
    errors.isAdult = "You must confirm you are the parent/guardian submitting this RSVP.";
  }
  if (!values.agreesToConduct) {
    errors.agreesToConduct = "You must agree to the code of conduct.";
  }
  if (!values.agreesToPrivacy) {
    errors.agreesToPrivacy = "You must acknowledge the privacy policy.";
  }
  if (!values.agreesToTerms) {
    errors.agreesToTerms = "You must agree to the terms.";
  }

  return errors;
}

export function validateContactForm(values) {
  const errors = {};
  if (!values.name || !values.name.trim()) {
    errors.name = "Name is required.";
  }
  if (!values.email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(values.email.trim())) {
    errors.email = "Enter a valid email address.";
  }
  if (!values.message || values.message.trim().length < 5) {
    errors.message = "Please enter a message of at least 5 characters.";
  }
  return errors;
}

export function hasErrors(errors) {
  return Object.keys(errors).length > 0;
}
